import { COMPOSE_ONLY_ATTACHMENT_CLASS_NAME } from 'owa-attachment-link-common';
import { displaySpinnerOverlay } from 'owa-compose-link';
import { SPINNER_CLASSNAME } from '../constants';

export function displaySpinner(anchorElement: HTMLAnchorElement): Node[] {
    anchorElement.setAttribute('contenteditable', 'false');
    anchorElement.style.pointerEvents = 'none';
    anchorElement.addEventListener('click', (event: MouseEvent) => {
        event.preventDefault();
    });

    const spinnerContainer: HTMLElement = document.createElement('span');
    spinnerContainer.className = SPINNER_CLASSNAME + ' ' + COMPOSE_ONLY_ATTACHMENT_CLASS_NAME;
    anchorElement.appendChild(spinnerContainer);
    displaySpinnerOverlay(spinnerContainer);
    return [spinnerContainer];
}
